import {gql} from '@apollo/client';

export const GET_COMMON_CONFIG_QUERY = gql`
	query ($locale: LanguagesCamelType!) {
		getStoreCommonConfig(locale: $locale) {
			home {
				location
				shopBackgroundImage
				primaryShopLogo
				secondaryShopLogo
			}
			contact {
				email
				telNumber
				whatsapp
				telegram
			}
			socialLinks {
				title
				icon
				url
			}
			currencies {
				title
				symbol
				main
				left
			}
		}
	}
`;

export const GET_HOME_QUERY = gql`
	query ($locale: LanguagesCamelType! $currency: String!) {
		getStoreCommonConfig(locale: $locale) {
			home {
				location
				shopBackgroundImage
				primaryShopLogo
				secondaryShopLogo
			}
			contact {
				email
				telNumber
				whatsapp
				telegram
			}
			socialLinks {
				title
				icon
				url
			}
			currencies {
				title
				symbol
				main
				left
			}
		}
		getClientSelfNullable {
			fullName
			email
			image
			clientType
		}
		getPublicStoreProductCategories(locale: $locale) {
			title
			alt
			icon
			image
			subcategories {
				title
				alt
			}
		}
		getPublicStoreProductBrands(locale: $locale) {
			title
			alt
		}
		getPublicStoreProductBrandsWithImage(locale: $locale) {
			alt
			image
			title
		}
		getPublicHomeBannerCoupons(locale: $locale) {
			id
			title
			validFrom
			validTo
			discount
			quantity
			image
		}
		getPublicStoreBannerProducts(locale: $locale currency: $currency) {
			id
			alt
			title
			coverImage
			discount
			tag
			prices {
				currencyObj {
					title
					symbol
					left
				}
				overprice
				price
				wholesalePrice
			}
			category {
				title
				alt
			}
			subcategory {
				title
				alt
				category {
					title
					alt
				}
			}
			brand {
				title
				alt
			}
		}
		getPublicStoreHomeFeatures(locale: $locale) {
			title
			subtitle
			icon
		}
		getPublicHomeProducts(locale: $locale currency: $currency) {
			sale {
				id
				alt
				coverImage
				discount
				prices {
					currencyObj {
						title
						symbol
						left
					}
					overprice
					price
					wholesalePrice
				}
				quantity
				reviewComputed {
					average
					count
				}
				status
				tag
				title
				descriptionShort
				category {
					title
					alt
				}
				subcategory {
					title
					alt
					category {
						title
						alt
					}
				}
				brand {
					title
					alt
				}
			}
			hot {
				id
				alt
				coverImage
				discount
				prices {
					currencyObj {
						title
						symbol
						left
					}
					overprice
					price
					wholesalePrice
				}
				quantity
				reviewComputed {
					average
					count
				}
				status
				tag
				title
				descriptionShort
				category {
					title
					alt
				}
				subcategory {
					title
					alt
					category {
						title
						alt
					}
				}
				brand {
					title
					alt
				}
			}
			limited {
				id
				alt
				coverImage
				discount
				prices {
					currencyObj {
						title
						symbol
						left
					}
					overprice
					price
					wholesalePrice
				}
				quantity
				reviewComputed {
					average
					count
				}
				status
				tag
				title
				descriptionShort
				category {
					title
					alt
				}
				subcategory {
					title
					alt
					category {
						title
						alt
					}
				}
				brand {
					title
					alt
				}
			}
			new {
				id
				alt
				coverImage
				discount
				prices {
					currencyObj {
						title
						symbol
						left
					}
					overprice
					price
					wholesalePrice
				}
				quantity
				reviewComputed {
					average
					count
				}
				status
				tag
				title
				descriptionShort
				category {
					title
					alt
				}
				subcategory {
					title
					alt
					category {
						title
						alt
					}
				}
				brand {
					title
					alt
				}
			}
		}
		getPublicHomeBlogs(locale: $locale) {
			alt
			title
			thesis
			timeToRead
			wordCount
			user {
				shortFullName
				image
			}
			coverImage
			createdAt
		}
	}
`;

export const GET_PRODUCTS_BY_IDS_CART_WISHLIST_QUERY = gql`
	query (
		$locale: LanguagesCamelType!
		$currency: String!
		$cartIds: [Int!]!
		$wishlistIds: [Int!]!
	) {
		getProductsByIdsCartWishlist(
			locale: $locale
			currency: $currency
			cartIds: $cartIds
			wishlistIds: $wishlistIds
		) {
			cart {
				id
				alt
				title
				coverImage
				discount
				tag
				prices {
					currencyObj {
						title
						symbol
						left
					}
					overprice
					price
					wholesalePrice
				}
			}
			wishlist {
				id
				alt
				title
				coverImage
				discount
				tag
				prices {
					currencyObj {
						title
						symbol
						left
					}
					overprice
					price
					wholesalePrice
				}
			}
		}
	}
`;

export const GET_CATALOG_QUERY = gql`
	query (
		$locale: LanguagesCamelType!
		$currency: String!
		$productsTake: Int!
		$search: String
		$category: String
		$subcategory: String
		$brand: String
		$tag: String
	) {
		getStoreCommonConfig(locale: $locale) {
			home {
				location
				shopBackgroundImage
				primaryShopLogo
				secondaryShopLogo
			}
			contact {
				email
				telNumber
				whatsapp
				telegram
			}
			socialLinks {
				title
				icon
				url
			}
			currencies {
				title
				symbol
				main
				left
			}
		}
		getPublicStoreProductCategories(locale: $locale) {
			title
			icon
			alt
			subcategories {
				title
				alt
			}
		}
		getPublicStoreProductBrands(locale: $locale) {
			title
			alt
		}
		getPublicProductsPaginated(
			locale: $locale
			currency: $currency
			data: {
				query: $search
				category: $category
				subcategory: $subcategory
				brand: $brand
				tag: $tag
				pagination: {
					skip: 0
					take: $productsTake
				}
				orderBy: [{
					fieldName: "reviewComputed.average"
					direction: DESC,
					nulls: LAST
				}]
			}
		) {
			hasMore
			total
			items {
				id
				title
				descriptionShort
				alt
				coverImage
				discount
				prices {
					currencyObj {
						title
						symbol
						left
					}
					overprice
					price
					wholesalePrice
				}
				quantity
				reviewComputed {
					average
					count
				}
				status
				tag
				category {
					title
					alt
				}
				subcategory {
					title
					alt
					category {
						title
						alt
					}
				}
				brand {
					title
					alt
				}
				createdAt
			}
		}
	}
`;

export const GET_PRODUCTS_QUERY = gql`
	query (
		$locale: LanguagesCamelType!
		$currency: String!
		$take: Int!
		$skip: Int!
		$orderBy: [OrderByInput!]
		$search: String
		$byPriceFrom: Int
		$byPriceTo: Int
		$category: String
		$subcategory: String
		$brand: String
		$tag: String
	) {
		getPublicProductsPaginated(
			locale: $locale
			currency: $currency
			data: {
				pagination: {
					skip: $skip
					take: $take
				}
				orderBy: $orderBy
				byPriceFrom: $byPriceFrom
				byPriceTo: $byPriceTo
				query: $search
				category: $category
				subcategory: $subcategory
				brand: $brand
				tag: $tag
			}
		) {
			hasMore
			total
			items {
				id
				title
				descriptionShort
				alt
				coverImage
				discount
				prices {
					currencyObj {
						title
						symbol
						left
					}
					overprice
					price
					wholesalePrice
				}
				quantity
				reviewComputed {
					average
					count
				}
				status
				tag
				category {
					title
					alt
				}
				subcategory {
					title
					alt
					category {
						title
						alt
					}
				}
				brand {
					title
					alt
				}
				createdAt
			}
		}
	}
`;

export const GET_PRODUCT_QUERY = gql`
	query (
		$locale: LanguagesCamelType!
		$currency: String!
		$alt: String!
	) {
		getStoreCommonConfig(locale: $locale) {
			home {
				location
				shopBackgroundImage
				primaryShopLogo
				secondaryShopLogo
			}
			contact {
				email
				telNumber
				whatsapp
				telegram
			}
			socialLinks {
				title
				icon
				url
			}
			currencies {
				title
				symbol
				main
				left
			}
		}
		getPublicProduct(
			alt: $alt
			locale: $locale
			currency: $currency
		) {
			id
			alt
			title
			descriptionShort
			description
			discount
			images
			prices {
				currencyObj {
					title
					symbol
					left
				}
				overprice
				price
				wholesalePrice
			}
			quantity
			reviewComputed {
				average
				count
			}
			reviews {
				id
				client {
					email
					fullName
					image
					clientType
				}
				value
				comment
				createdAt
				repliesCount {
					count
				}
			}
			status
			tag
			category {
				id
				title
				alt
			}
			subcategory {
				id
				title
				alt
				category {
					title
					alt
				}
			}
			brand {
				id
				title
				alt
			}
			createdAt
		}
		getClientSelfNullable {
			fullName
			email
			image
			clientType
		}
		getPublicRelatedProducts(
			alt: $alt
			locale: $locale
			currency: $currency
		) {
			id
			title
			descriptionShort
			alt
			coverImage
			discount
			prices {
				currencyObj {
					title
					symbol
					left
				}
				overprice
				price
				wholesalePrice
			}
			quantity
			reviewComputed {
				average
				count
			}
			status
			tag
			category {
				title
				alt
			}
			subcategory {
				title
				alt
				category {
					title
					alt
				}
			}
			brand {
				title
				alt
			}
			createdAt
		}
	}
`;

export const GET_PRODUCT_REVIEW_REPLIES_PAGINATED_QUERY = gql`
	query (
		$reviewId: Int!
		$ignoreIds: [Int!]
		$take: Int!
		$skip: Int!
	) {
		getPublicProductReviewReplyPaginated(
			data: {
				reviewId: $reviewId
				ignoreIds: $ignoreIds
				pagination: {
					skip: $skip
					take: $take
				}
				orderBy: []
			}
		) {
			hasMore
			total
			items {
				id
				client {
					email
					fullName
					image
					clientType
				}
				comment
				createdAt
			}
		}
	}
`;

export const GET_BLOGS_PAGE_QUERY = gql`
	query (
		$locale: LanguagesCamelType!
		$blogsTake: Int!
	) {
		getStoreCommonConfig(locale: $locale) {
			home {
				location
				shopBackgroundImage
				primaryShopLogo
				secondaryShopLogo
			}
			contact {
				email
				telNumber
				whatsapp
				telegram
			}
			socialLinks {
				title
				icon
				url
			}
			currencies {
				title
				symbol
				main
				left
			}
		}
		getPublicBlogPaginated(
			locale: $locale
			data: {
				pagination: {
					skip: 0
					take: $blogsTake
				}
				orderBy: [{
					fieldName: "blog.createdAt"
					direction: DESC
				}]
			}
		) {
			hasMore
			total
			items {
				alt
				title
				thesis
				timeToRead
				wordCount
				user {
					shortFullName
					image
				}
				coverImage
				createdAt
			}
		}
	}
`;

export const GET_BLOGS_QUERY = gql`
	query (
		$locale: LanguagesCamelType!
		$take: Int!
		$skip: Int!
		$orderBy: [OrderByInput!]
	) {
		getPublicBlogPaginated(
			locale: $locale
			data: {
				pagination: {
					skip: $skip
					take: $take
				}
				orderBy: $orderBy
			}
		) {
			hasMore
			total
			items {
				alt
				title
				thesis
				timeToRead
				wordCount
				user {
					shortFullName
					image
				}
				coverImage
				createdAt
			}
		}
	}
`;

export const GET_BLOG_QUERY = gql`
	query (
		$locale: LanguagesCamelType!
		$alt: String!
	) {
		getStoreCommonConfig(locale: $locale) {
			home {
				location
				shopBackgroundImage
				primaryShopLogo
				secondaryShopLogo
			}
			contact {
				email
				telNumber
				whatsapp
				telegram
			}
			socialLinks {
				title
				icon
				url
			}
			currencies {
				title
				symbol
				main
				left
			}
		}
		getPublicBlog(
			alt: $alt
			locale: $locale
		) {
			alt
			title
			thesis
			content
			timeToRead
			wordCount
			user {
				shortFullName
				image
			}
			tags
			coverImage
			createdAt
		}
		getPublicRelatedBlogs(
			alt: $alt
			locale: $locale
		) {
			alt
			title
			thesis
			timeToRead
			wordCount
			user {
				shortFullName
				image
			}
			coverImage
			createdAt
		}
	}
`;

export const GET_FAQ_QUERY = gql`
	query ($locale: LanguagesCamelType!) {
		getStoreCommonConfig(locale: $locale) {
			home {
				location
				shopBackgroundImage
				primaryShopLogo
				secondaryShopLogo
			}
			contact {
				email
				telNumber
				whatsapp
				telegram
			}
			socialLinks {
				title
				icon
				url
			}
			currencies {
				title
				symbol
				main
				left
			}
		}
		getPublicFaqList(type: SHOP, locale: $locale) {
			id
			question
			answer
			url
		}
	}
`;

export const GET_CONTACTS_QUERY = gql`
	query ($locale: LanguagesCamelType!) {
		getStoreCommonConfig(locale: $locale) {
			home {
				location
				shopBackgroundImage
				primaryShopLogo
				secondaryShopLogo
			}
			contact {
				email
				telNumber
				whatsapp
				telegram
			}
			socialLinks {
				title
				icon
				url
			}
			currencies {
				title
				symbol
				main
				left
			}
		}
		getPublicContacts(type: SHOP) {
			telNumber
			email
			whatsapp
			telegram
		}
	}
`;

export const GET_CART_QUERY = gql`
	query(
		$locale: LanguagesCamelType!
	) {
		getStoreCommonConfig(locale: $locale) {
			home {
				location
				shopBackgroundImage
				primaryShopLogo
				secondaryShopLogo
			}
			contact {
				email
				telNumber
				whatsapp
				telegram
			}
			socialLinks {
				title
				icon
				url
			}
			currencies {
				title
				symbol
				main
				left
			}
		}
		getAutoUseCoupon(locale: $locale) {
			title
			discount
			value
			autoUse
			firstOrder
		}
		getFirstOrderCoupon(locale: $locale) {
			title
			discount
		}
	}
`;


export const GET_WISHLIST_QUERY = gql`
	query(
		$locale: LanguagesCamelType!
	) {
		getStoreCommonConfig(locale: $locale) {
			home {
				location
				shopBackgroundImage
				primaryShopLogo
				secondaryShopLogo
			}
			contact {
				email
				telNumber
				whatsapp
				telegram
			}
			socialLinks {
				title
				icon
				url
			}
			currencies {
				title
				symbol
				main
				left
			}
		}
	}
`;

export const GET_CHECKOUT_QUERY = gql`
	query(
		$locale: LanguagesCamelType!
	) {
		getStoreCommonConfig(locale: $locale) {
			home {
				location
				shopBackgroundImage
				primaryShopLogo
				secondaryShopLogo
			}
			contact {
				email
				telNumber
				whatsapp
				telegram
			}
			socialLinks {
				title
				icon
				url
			}
			currencies {
				title
				symbol
				main
				left
			}
		}
		getAutoUseCoupon(locale: $locale) {
			title
			discount
			value
		}
		getFirstOrderCoupon(locale: $locale) {
			title
			discount
		}
		getBranchesForClient(locale: $locale) {
			id
			title
			address
		}
	}
`;
